import ania from '../assets/ania.jpg';
import brzoza from '../assets/brzoza.jpg';
import julianw from '../assets/julianw.jpg';
import krzysiek from '../assets/krzysiek.jpg';
import otto from '../assets/otto.jpg'
import jakubg from '../assets/jakubg.jpg'
import wiktoria from '../assets/wiktoria.jpg'
import banan from '../assets/banan.jpg'
import paschlik from '../assets/paschlik.png'
import julek from '../assets/julek.jpg'
import fabiano from '../assets/fabiano.jpg'

const workshops = [
  {
    id: '1',
    title: 'Stretching',
    instructor: 'Ania Palenga',
    image: ania,
    short: 'Warsztaty ze stretchingu. Kliknij, aby zobaczyć pełen opis.',
    details: [
      'Na warsztatach sprawdzicie mobilność w barkach, plecach i biodrach. Pogłębimy zakresy szpagatu tureckiego oraz francuskiego, a także gięcia w plecach. Na koniec będzie też czas na ćwiczenia z rozciągania potreningowego.',
      'Warsztaty będą podzielone na dwie osobne części - jedną skupioną na kręgosłupie oraz drugą, skupioną na szpagatach.',
      'Warto mieć z sobą wygodny dres (długie nogawki), najlepiej bez twardych elementów oraz matę.',
    ],
  },

  {
    id: '2',
    title: 'Warsztaty z double staff',
    instructor: 'Brzoza',
    image: brzoza,
    short: 'Warsztaty z double staff. Kliknij, aby zobaczyć pełen opis.',
    details: [
      "Brzoza podzieli się z Wami swoimi odkryciami w zakresie body trace'ów oraz innych tricków ukradzionych z poi, jak sam o nich mówi.",
      'Podczas warsztatów zajmiecie się wsadzaniem staffów tam, gdzie kręci się niewygodnie (pod pachę, za plecy i dookoła głowy), by wejść w triki, które znamy głównie z poi. Zahaczycie o meltdowny, archery, crossery i inne triki, które kręcąc dablami można ukraść od poikarzy. Zgadza się - ukradniemy, ale trzeba było pilnować.',
    ],
  },
  {
    id: '3',
    title: 'Warsztaty z passingów',
    instructor: 'Julian Waglewski',
    image: julianw,
    short: 'Warsztaty z passingów. Kliknij, aby zobaczyć pełen opis.',
    details: [
      'Warsztat 1:',
      "Pass pass self i tylko dziwniej. 2 count'a i 4 count'a zostawiamy z tyłu i otwieramy drzwi do inny wzorów topiących mózg. 6 maczug, 2 osoby. Wymagane jakieś doświadczenie ze standardowymi passingami.",
      'Warsztat 2:',
      'Czy umiesz liczyć do 12? 6 maczug, 2 osoby. Wymagane jakieś doświadczenie z 3 countem.',
    ],
  },
  {
    id: '4',
    title: 'Współczesne techniki maczugowe',
    instructor: 'Krzysiek Pacholik',
    image: krzysiek,
    short: 'Współczesne techniki maczugowe. Kliknij, aby zobaczyć pełen opis.',
    details: [
      'Warsztaty dotyczyć będą współczesnych technik maczugowych, takich jak manipulacje, body rolle i body throwy. Będziecie mogli dowiedzieć się na nich, jak uatrakcyjnić waszą maczugową żonglerkę i wyjść poza standardowe, oldschoolowe techniki rzucania.',
      'Utrzymywanie maczugowej kaskady jest mile widziane, ale nieobowiązkowe.',
    ],
  },
  {
    id: '5',
    title: 'Warsztaty i wykład',
    instructor: 'Otto',
    image: otto,
    short: 'Warsztaty z legosów i steali. Wykład o pokazach dla dzieci. Kliknij, aby zobaczyć pełen opis.',
    details: ['Otto powie Wam słów kilka o pokazach dla dzieci, czyli używaj oczu, uszu i… zębów! Dowiecie się czego nauczyło go pierwsze 199,5pokazów dla dzieci.',
        'W ramach warsztatów za to będziecie mogli spróbować trochę podstaw legosów i kradzieży. Lego będą dla każdego, do kradzieży wymagana stabilna kaskada.'],
  },
  {
    id: '6',
    title: 'Warsztaty z fotografii',
    instructor: 'Jakub Gadaj',
    image: jakubg,
    short: 'Warsztaty z fotografii. Kliknij, aby zobaczyć pełen opis.',
    details: ['Jak sam opowiada: fotografia jest z nami już od około 200 lat! Nazywam się Kuba, a aparat jest moim rekwizytem od około 12 lat. Chciałbym opowiedzieć wam o mojej drodze, a przede wszystkim kluczowych elementach idei fotografii oraz dlaczego każdy z nas ma w kieszeni niesamowite narzędzie.', 'W trakcie warsztatu będziecie mieli okazję zająć się aparatem jako narzędziem do animacji kultury, tworzenia wyrazu twórczego, tworzenia materiałów promocyjnych i dokumentacji. Przejrzycie wachlarz możliwości jakie daje Wam to narzędzie. Poruszycie również krótko i zwięźle temat technikaliów Waszych urządzeń. Na koniec zmierzycie Wasze przemyślenia z możliwościami jakie daje nam AI w dziedzinie fotografii.'],
  },
    {
    id: '7',
    title: 'Podstawy pedagogiki cyrku',
    instructor: 'Wiktoria Witenberg',
    image: wiktoria,
    short: 'Warsztaty z pedagogiki cyrku. Kliknij, aby zobaczyć pełen opis.',
    details: ['Wiktoria Witenberg poprowadzi dla Was warsztaty z podstaw pedagogiki cyrku, a dokładniej z tego jak uczyć żonglerki od podstaw.', 'Jak sama mówi - można przyjść żeby się nauczyć jak uczyć i można przyjść żeby się nauczyć jak żonglować.'],
  },
      {
    id: '8',
    title: 'Flow Arts',
    instructor: 'Adam Batko-Banach ',
    image: banan,
    short: 'Warsztaty z flow arts. Kliknij, aby zobaczyć pełen opis.',
    details: ['Potrafisz kilka sztuczek, ale nie wiesz jak przekazać je innym? Trudno Ci uczyć zaawansowanych technik? A może chcesz z większą świadomością podejść do własnego procesu treningowego?',
      'Projektowanie to jeden z kluczowych etapów w pracy trenera. W 105 minut porozmawiacie o tym, co wpływa na design Waszych warsztatów, poznacie prosty szablon ich tworzenia oraz wymyślicie kilka autorskich narzędzi trenerskich. Docelowo każda osoba uczestnicząca zakończy warsztaty z gotowym scenariuszem, który może przetestować w praktyce.'
    ],
  },
      {
    id: '9',
    title: 'Steve na kiju kontaktowym',
    instructor: 'Adrian Paschlik',
    image: paschlik,
    short: 'Warsztaty z stevea  na kiju kontaktowym. Kliknij, aby zobaczyć pełen opis.',
    details: ['Steve podstawowy',
      'Warsztat będzie szczegółowo poświęcony technice Steve od zera. Jeśli Twój Steve jest niestabilny i nie masz pojęcia dlaczego, lub stawiasz pierwsze kroki, to warsztat dla Ciebie! co trzeba umieć? Nic :D Co trzeba przynieść na warsztaty? Długi kij kontaktowy, obowiązkowy prosty',
      'Steve zaawansowany + rozwinięcia',
      'W tym warsztacie będziecie mogli rozwinąć Stevea o kolejne warianty i potraktować go jako uniwersalną "bazę wypadową" do szeroko pojętego kontaktu horyzontalnego.Co trzeba umieć? Stabilny Steve Co trzeba przynieść na warsztaty? Długi kij kontaktowy, obowiązkowy prosty'
    ],
  },
        {
    id: '10',
    title: 'Dragon staff',
    instructor: 'Juliusz Lewandowski',
    image: julek,
    short: 'Warsztaty z dragon staffa. Kliknij, aby zobaczyć pełen opis.',
    details: ['Zapraszamy na warsztaty gdzie wybierzecie się na polowanie na najrzadsze triki z dziedziny nowej szkoły dragon staffa. Reverse Matrixy, Barrel- Spear Dullumy i Windy- takich cukiereczków możecie się spodziewać. Prowadzone będą z myślą o ludziach, którzy dają sobie czas by eksplorować rzeczy wymagające skupienia, stąd poziom raczej zaawansowany.'],
  },
        {
    id: '11',
    title: 'Manipulacja kapeluszami',
    instructor: 'Fabiano',
    image: fabiano,
    short: 'Warsztaty z manipulacji kapeluszami. Kliknij, aby zobaczyć pełen opis.',
    details: ['Manipulacja kapeluszami i gestem - będzie to przestrzeń do eksplorowania relacji pomiędzy ciałem, gestem i obiektem w sztuce cyrkowej. W ramach warsztatu będziecie mogli poprawić swoją pracę z przestrzenią sceny oraz napędzić kreatywność w wyrażaniu siebie.',
      'Warsztat podzielony będzie na dwie części. Ilość miejsc ograniczona 😉'
    ],
  },
];

export default workshops;
